import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { ROUTE_PATH } from 'app/lib/routing/constants';
import { Skeleton } from 'app/modules/Betting';

import { entityLoading, entityRequested, getSortedSportIds } from '../../selectors/gridEntities';

export const SportRedirect: FC = () => {
  const sportIds = useSelector(getSortedSportIds);
  const loading = useSelector(entityLoading);
  const requested = useSelector(entityRequested);

  if (!requested && loading) {
    return (
      <Skeleton />
    );
  }

  return <Redirect to={`${ROUTE_PATH.PREMATCH_SPORTS}/${sportIds.get(0)}`} />;
};
